export default [
  {
    score: '<580',
    color: '#FC0D0D',
    angle: -89,
    d: {
      desktop: 'M89.4404 156.605L1.93273 155.922C2.18453 141.331 4.46964 126.847 8.72201 112.887L92.1798 139.207C90.5323 144.867 89.6118 150.713 89.4404 156.605Z',
      mobile: 'M68.8052 120.875L1.55787 120.35C1.77971 109.285 3.51239 98.3023 6.70779 87.7066L70.8431 107.933C69.6435 112.149 68.9592 116.495 68.8052 120.875Z',
    },
  },
  {
    score: '580-599',
    color: '#EE4035',
    angle: -70,
    d: {
      desktop: 'M93.4298 135.328L10.3996 107.697C15.1378 93.8957 21.7968 80.8304 30.1801 68.8869L101.317 119.853C98.0361 124.652 95.3853 129.853 93.4298 135.328Z',
      mobile: 'M72.0208 104.279L8.21407 83.0453C11.8369 72.5886 16.8859 62.6822 23.218 53.6067L77.8851 92.7731C75.4687 96.3548 73.4993 100.219 72.0208 104.279Z',
    },
  },
  {
    score: '600-619',
    color: '#EE7835',
    angle: -51,
    d: {
      desktop: 'M103.726 116.554L33.3994 64.4714C42.2019 52.8296 52.5705 42.4599 64.2108 33.6563L116.287 103.991C111.59 107.636 107.37 111.856 103.726 116.554Z',
      mobile: 'M80.1542 89.6651L26.11 49.6409C32.8104 40.8302 40.6725 32.9671 49.4821 26.266L89.5017 80.3165C86.0239 83.0483 82.8857 86.1869 80.1542 89.6651Z',
    },
  },
  {
    score: '620-639',
    color: '#EEA435',
    angle: -31,
    d: {
      desktop: 'M119.587 101.588L68.6262 30.4408C80.5676 22.0571 93.6304 15.3977 107.429 10.6588L135.059 93.7C129.585 95.6556 124.385 98.3068 119.587 101.588Z',
      mobile: 'M92.6097 78.0533L53.4478 23.3783C62.5216 17.0459 72.4261 11.9966 82.8807 8.37329L104.114 72.1884C100.054 73.6671 96.1909 75.6367 92.6097 78.0533Z',
    },
  },
  {
    score: '640-659',
    color: '#EED035',
    angle: -10,
    d: {
      desktop: 'M138.942 92.4465L112.624 8.976C126.582 4.72462 141.065 2.44067 155.654 2.19017L156.337 89.7085C150.446 89.8794 144.6 90.7995 138.942 92.4465Z',
      mobile: 'M107.769 71.007L87.5447 6.86183C98.1392 3.66719 109.121 1.9354 120.184 1.71454L120.709 68.9701C116.329 69.1238 111.984 69.8077 107.769 71.007Z',
    },
  },
  {
    score: '660-679',
    color: '#F1F61C',
    angle: 10,
    d: {
      desktop: 'M161.111 2.18531C175.7 2.43718 190.183 4.72255 204.14 8.97537L177.823 92.4432C172.164 90.7956 166.319 89.875 160.428 89.7036L161.111 2.18531Z',
      mobile: 'M125.087 1.71085C136.151 1.93276 147.133 3.66563 157.727 6.86137L137.503 71.0044C133.287 69.8048 128.942 69.1205 124.562 68.9664L125.087 1.71085Z',
    },
  },
  {
    score: '680-699',
    color: '#D7F61C',
    angle: 31,
    d: {
      desktop: 'M248.131 30.4409L197.171 101.587C192.373 98.3058 187.172 95.6547 181.698 93.6991L209.326 10.6588C223.126 15.3974 236.189 22.0569 248.131 30.4409Z',
      mobile: 'M191.82 23.3783L152.658 78.0526C149.077 75.636 145.213 73.6664 141.154 72.1877L162.385 8.37325C172.84 11.9964 182.745 17.0457 191.82 23.3783Z',
    },
  },
  {
    score: '700-719',
    color: '#BDF61C',
    angle: 51,
    d: {
      desktop: 'M200.472 103.991L252.549 33.6563C264.189 42.4603 274.557 52.83 283.36 64.4714L213.034 116.554C209.389 111.856 205.169 107.636 200.472 103.991Z',
      mobile: 'M155.768 80.3165L195.788 26.266C204.597 32.9674 212.459 40.8305 219.16 49.6409L165.116 89.6651C162.384 86.1869 159.246 83.0483 155.768 80.3165Z',
    },
  },
  {
    score: '720-739',
    color: '#94EA07',
    angle: 70,
    d: {
      desktop: 'M223.324 135.328C221.369 129.853 218.718 124.652 215.437 119.853L286.576 68.8869C294.959 80.8305 301.618 93.8958 306.356 107.697L223.324 135.328Z',
      mobile: 'M173.243 104.279C171.764 100.219 169.795 96.3548 167.379 92.7731L222.047 53.6067C228.379 62.6823 233.428 72.5887 237.05 83.0453L173.243 104.279Z',
    },
  },
  {
    score: '>740',
    color: '#42EA07',
    angle: 89,
    d: {
      desktop: 'M224.578 139.208L308.036 112.887C312.288 126.847 314.572 141.331 314.824 155.922L227.316 156.605C227.145 150.713 226.225 144.867 224.578 139.208Z',
      mobile: 'M174.423 107.933L238.559 87.7066C241.754 98.3024 243.486 109.285 243.707 120.35L176.46 120.875C176.306 116.495 175.623 112.149 174.423 107.933Z',
    },
  },
];
